import React from 'react';
import {useFormInput} from '@netx/core-components/Form/hooks';
import type {WithLegacyCommonFormFieldProps} from '@netx/core-components/Form/types';
import {useConstCallback} from '@netx/core-components/hooks/useConstCallback';
import {splitEventHandler} from '@netx/core-next/utils';
import {URLTextField, type URLTextFieldProps} from './URLTextField';
import {validateURL} from './utils';

export interface LegacyFormURLTextFieldProps
	extends WithLegacyCommonFormFieldProps<URLTextFieldProps> {}

export const LegacyFormURLTextFieldPrimitive = (
	{
		error,
		form,
		formFieldOptions,
		onChange,
		...props
	}: LegacyFormURLTextFieldProps,
	ref: any,
) => {
	const fieldName = props.name || 'url';

	const _error = typeof error === 'string' ? error : error?.message;

	useFormInput(fieldName, props.value, form, {
		required: props.required,
		hasChanged: (value, originalValue) => {
			return value !== originalValue.replace(/^http(s)?:\/\//, '');
		},
		...formFieldOptions,
		validator: async (value) => {
			const result = validateURL(value);
			if (result !== true) return result;
			return formFieldOptions?.validator
				? formFieldOptions?.validator(value)
				: true;
		},
	});

	const handleChange = useConstCallback(
		splitEventHandler(onChange, (event, value) => {
			form?.setValue(fieldName, value);
		}),
	);

	return (
		<URLTextField ref={ref} error={_error} {...props} onChange={handleChange} />
	);
};

export const LegacyFormURLTextField = React.forwardRef(
	LegacyFormURLTextFieldPrimitive,
);

export default LegacyFormURLTextField;
